import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    profileToEditId: null
  },

  mutations: {
    PROFILE_TO_EDIT_SELECTED (state, profileId) {
      state.profileToEditId = profileId
    },
    CLEAN_PROFILE_TO_EDIT (state) {
      state.profileToEditId = null
    }
  },

  actions: {
    getProfiles: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/accessProfile/').then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getOperatorProfiles: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        axios.get(url).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getFunctionalitiesGroups: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(response => {
            // Remove a funcionalidade 'Permitir emulacao de perfil MASTER'
            let group = response.data.find(el => el.id === 35)
            group.funcionalidades = group.funcionalidades.filter(func => func.id !== 206)

            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    newProfile: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/accessProfile', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getProfile: ({ commit }, idProfile) => {
      return new Promise((resolve, reject) => {
        axios.get('/accessProfile/find', { params: { idProfile: idProfile } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setProfileToEdit: ({ commit }, profileId) => {
      return new Promise((resolve, reject) => {
        commit('PROFILE_TO_EDIT_SELECTED', profileId)
        resolve()
      })
    },

    cleanProfileToEdit: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_PROFILE_TO_EDIT')
        resolve()
      })
    }
  },

  getters: {
    profileToEditId: state => state.profileToEditId
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/accessProfile.js